import React from "react";
import RaindropInput from "../raindrop-input/raindrop-input.tsx";

import Currency from "../currency/currency.tsx";

import ModelComponentAccountPlanExecutionSausage from "../model-component-account-plan-sausage-execution/model-component-account-plan-sausage-execution.js";
import RaindropDivider from "../raindrop-divider/raindrop-divider.js";
import Spacer from "../spacer/spacer.js";
import ModelComponent from "../model-component/model-component.tsx";

const ModelComponentAccountPlanExecution = ({
  accountPlanExecutionId,
  subunits,
  subunitsCurrency,
  subunitsFee,
  subunitsRaindrop,
  paymentProviderIdentifierStripe,
  accountPlanExecutionSausages,
  availableAt,
}) => {
  return (
    <ModelComponent
      modelId={accountPlanExecutionId}
      colorBorderAccent="dark:border-color-dark-model-account-plan-execution border-color-model-account-plan-execution"
    >
      <RaindropInput
        label={"Executed At"}
        value={"2021-01-01"}
        onChange={() => {}}
        icon={null}
        isEditing={false}
        isShowLabel={true}
      />

      <RaindropInput
        label={"Stripe Charge ID"}
        value={paymentProviderIdentifierStripe}
        example="pi_234234234"
        onChange={() => {}}
        icon={null}
        isEditing={false}
        isShowLabel={true}
      />

      <RaindropInput
        label={"Available At"}
        value={availableAt}
        example="2024-05-04"
        onChange={() => {}}
        icon={null}
        isEditing={false}
        isShowLabel={true}
      />

      <div
        className="flex flex-col gap-4  rounded-lg p-4 
        dark:bg-color-dark-background-tertiary bg-color-background-tertiary
        
      "
      >
        <div className="flex flex-row gap-1 w-full">
          <div className="text-color-dark-text-secondary whitespace-nowrap">
            Raindrop Revenue
          </div>
          <Spacer />
          <Currency
            subunits={subunitsRaindrop}
            subunitsCurrency={subunitsCurrency}
          />
        </div>
        <div className="flex flex-row gap-1 w-full">
          <div className="text-color-dark-text-secondary whitespace-nowrap">
            Stripe Fees
          </div>
          <Spacer />
          <Currency
            subunits={subunitsFee}
            subunitsCurrency={subunitsCurrency}
          />
        </div>
        {accountPlanExecutionSausages.map((sausageExecution) => (
          <ModelComponentAccountPlanExecutionSausage
            accountPlanSausageId={sausageExecution.id}
            organisationId={sausageExecution.organisation}
            organisationName={sausageExecution.organisation_name}
            organisationLogoUrl={sausageExecution.organisation_logo_url}
            subunits={sausageExecution.subunits}
            subunitsCurrency={sausageExecution.subunits_currency}
          />
        ))}

        <RaindropDivider />
        <div className="flex flex-row justify-center items-center">
          <div className="whitespace-nowrap font-bold">Total contribution</div>
          <Spacer />
          <Currency
            subunits={subunits}
            subunitsCurrency={subunitsCurrency}
            isStylised={true}
          />
        </div>
      </div>
    </ModelComponent>
  );
};

export default ModelComponentAccountPlanExecution;
